import { render, staticRenderFns } from "./SiteUsageCensus.vue?vue&type=template&id=38fc8b1a&scoped=true&"
import script from "./SiteUsageCensus.vue?vue&type=script&lang=js&"
export * from "./SiteUsageCensus.vue?vue&type=script&lang=js&"
import style0 from "./SiteUsageCensus.vue?vue&type=style&index=0&id=38fc8b1a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc8b1a",
  null
  
)

export default component.exports